<template>
  <div class="scroll-div" v-loading="loadingReply">
    <div class="page-header-class padding10px">
      <el-button type="text" icon="el-icon-d-arrow-left" @click="close"
        >返回</el-button
      >
      <template v-if="isEmail">
        <el-button type="primary" @click="setContent">回复</el-button>
        <el-button type="warning" @click="markMail">标记邮件</el-button>
        <el-select
          v-model="mailTxt"
          clearable
          filterable
          placeholder="请选择"
          style="width: 130px; margin-left: 10px"
        >
          <el-option
            v-for="(val, i) in mailType"
            :label="val.name"
            :value="val.key"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          v-model="mailTitle"
          clearable
          filterable
          placeholder="---历史邮件查询------"
          style="width: 380px; margin-left: 10px"
          @change="setMailDetail"
        >
          <el-option
            v-for="(val, i) in MailList"
            :label="val.title"
            :value="val.id"
            :key="i"
          ></el-option>
        </el-select>
      </template>
    </div>

    <div class="replay-div" v-loading="loading">
      <!-- 原邮件详情 -->
      <div class="mail-detail">
        <div ref="message" class="border-box">
          <h2>{{ mailObj.subject }}</h2>
          <h4>发件人：{{ mailObj.sender }}</h4>
          <h4>收件人：{{ mailObj.recipients }}</h4>
          <h4>收件时间：{{ mailObj.sendDate }}</h4>
        </div>
        <div
          class="border-box"
          v-html="mailObj.htmlText || mailObj.contentText"
        ></div>
        <div
          class="border-box"
          v-show="mailImg.length > 0 || mailPdf.length > 0"
        >
          <p style="font-size: 14px; font-weight: bold; margin-bottom: 10px">
            <i class="el-icon-paperclip"></i>附件
          </p>
          <div v-show="mailImg.length > 0">
            <viewer style="display: flex" :images="mailImg">
              <img
                v-for="(src, i) in mailImg"
                :src="src"
                :key="i"
                style="
                  width: 60px;
                  height: 60px;
                  margin-left: 10px;
                  cursor: pointer;
                "
              />
            </viewer>
          </div>
          <div v-show="mailPdf.length > 0">
            <el-tag
              style="margin-left: 20px; margin-bottom: 10px; cursor: pointer"
              :key="index"
              v-for="(item, index) in mailPdf"
              size="medium"
              :disable-transitions="false"
              @click="toTab(item)"
            >
              <i class="el-icon-document"></i>
              <span>{{ item.attachmentName }}</span>
            </el-tag>
          </div>
        </div>

        <!-- AI 智能回复面板 -->
        <div
          class="ai-panel"
          v-if="isEmail"
          v-loading="aiLoading"
          element-loading-text="AI 正在重新生成回复..."
        >
          <div class="ai-panel-header">
            <div class="ai-title">
              <span class="ai-icon">🤖</span>
              <span class="ai-title-text">AI智能回复</span>
              <!-- <span class="ai-source">数据源：{{ aiInfo.dataSource }}</span> -->
            </div>
            <!-- <div class="ai-gen-time">生成时间：{{ aiInfo.generateTime }}</div> -->
          </div>

          <el-form
            :model="dataObj"
            :rules="rules"
            size="small"
            ref="ruleForm"
            label-position="top"
            class="ai-form"
          >
            <el-form-item label="邮件主题" prop="title">
              <el-input
                v-model="dataObj.title"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="收件人" prop="recipientAddress">
              <el-input
                v-model="dataObj.recipientAddress"
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label="模板选择" prop="templateId">
              <el-select
                v-model="dataObj.templateId"
                clearable
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="changeTemplate"
              >
                <el-option
                  v-for="(val, key, i) in templateList"
                  :label="val"
                  :value="val"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="正文" prop="content" class="content-item">
              <!-- 富文本共享工具栏（驱动当前激活的编辑器） -->
              <div class="ai-toolbar">
                <span class="tool-btn" @mousedown.prevent="exec('bold')"
                  ><b>B</b></span
                >
                <span class="tool-btn" @mousedown.prevent="exec('italic')"
                  ><i>I</i></span
                >
                <span class="tool-btn" @mousedown.prevent="exec('underline')"
                  ><u>U</u></span
                >
                <span
                  class="tool-btn"
                  @mousedown.prevent="exec('strikeThrough')"
                  ><s>S</s></span
                >
                <span class="tool-divider"></span>
                <span
                  class="tool-btn"
                  @mousedown.prevent="exec('formatBlock', '&lt;h1&gt;')"
                  >H<sub>1</sub></span
                >
                <span
                  class="tool-btn"
                  @mousedown.prevent="exec('formatBlock', '&lt;h2&gt;')"
                  >H<sub>2</sub></span
                >
                <span class="tool-divider"></span>
                <select
                  class="tool-select"
                  v-model="blockFormat"
                  @mousedown="saveSelection"
                  @change="onBlockChange"
                >
                  <option value="">Normal</option>
                  <option value="&lt;p&gt;">Normal</option>
                  <option value="&lt;h1&gt;">Heading 1</option>
                  <option value="&lt;h2&gt;">Heading 2</option>
                  <option value="&lt;h3&gt;">Heading 3</option>
                  <option value="&lt;blockquote&gt;">Quote</option>
                </select>
                <select
                  class="tool-select"
                  v-model="sizeFormat"
                  @mousedown="saveSelection"
                  @change="onSizeChange"
                >
                  <option value="">Normal</option>
                  <option value="1">Small</option>
                  <option value="3">Normal</option>
                  <option value="5">Large</option>
                  <option value="7">Huge</option>
                </select>
              </div>

              <div class="bilingual-wrap">
                <div class="bilingual-col">
                  <div class="bilingual-head">
                    <span>中文译文（可编辑）</span>
                    <el-select
                      v-model="langObj.from"
                      size="mini"
                      class="lang-select"
                    >
                      <el-option
                        v-for="(val, i) in languageArr"
                        :label="val.languageName"
                        :value="val.languageCode"
                        :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                  <div
                    class="rich-editor cn-editor"
                    contenteditable="true"
                    ref="cnEditor"
                    data-placeholder="请输入中文译文，编辑后可点击翻译同步右侧英文"
                    @focus="activeEditor = 'cn'"
                    @keyup="saveSelection"
                    @mouseup="saveSelection"
                    @input="onCnInput"
                  ></div>
                </div>

                <div class="bilingual-col">
                  <div class="bilingual-head">
                    <span>AI生成原文（英文）</span>
                    <el-select
                      v-model="langObj.to"
                      size="mini"
                      class="lang-select"
                    >
                      <el-option
                        v-for="(val, i) in languageArr"
                        :label="val.languageName"
                        :value="val.languageCode"
                        :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                  <div
                    class="rich-editor en-editor"
                    contenteditable="true"
                    ref="enEditor"
                    data-placeholder="AI生成的英文原文（发送内容）"
                    @focus="activeEditor = 'en'"
                    @keyup="saveSelection"
                    @mouseup="saveSelection"
                    @input="onEnInput"
                  ></div>
                </div>
              </div>

              <div class="translate-row">
                <el-button type="primary" size="small" @click="translateClick"
                  >翻译</el-button
                >
                <span class="translate-tip">将左侧中文翻译为右侧英文</span>
              </div>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="dataObj.remark"
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label-width="0px" class="template-item">
              <el-checkbox v-model="checked">设置为模板</el-checkbox>
              <template v-if="checked == 1">
                <el-select
                  v-model="dataObj.temLanguages"
                  clearable
                  filterable
                  placeholder="请选择模板语种"
                  style="width: 200px; margin-left: 10px"
                >
                  <el-option
                    v-for="(val, key, i) in dropList.TemplateLanguages"
                    :label="val"
                    :value="key"
                    :key="i"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="dataObj.temType"
                  clearable
                  filterable
                  placeholder="请选择模板类型"
                  style="width: 200px; margin-left: 10px"
                >
                  <el-option
                    v-for="(val, key, i) in dropList.TemplateType"
                    :label="val"
                    :value="key"
                    :key="i"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>

            <el-form-item label-width="0px">
              <div class="action-row">
                <el-button type="primary" @click="send()">发送</el-button>
                <el-button
                  type="primary"
                  @click="saveSlide()"
                  style="margin-left: 0px"
                  >存为草稿</el-button
                >
                <upload
                  buttonName="上传附件"
                  :url="url"
                  :param="uploadObj"
                  :text="''"
                  @getImgName="getImgName"
                  @getImgSrc="getImgSrc"
                  :accept="'.jpg,.jpeg,.png,.pdf'"
                ></upload>
                <el-button
                  type="warning"
                  icon="el-icon-refresh"
                  @click="regenerateAI"
                  >重新生成AI回复</el-button
                >
              </div>
            </el-form-item>

            <!-- 已上传附件 -->
            <div
              class="annex-wrap"
              v-show="imgName.length > 0 || pdfSrc.length > 0"
            >
              <el-tag
                class="tag-annex"
                v-for="(item, index) in imgName"
                :key="'img' + index"
                closable
                size="medium"
                :disable-transitions="false"
                @close="handleDel(index, item)"
                @click="seeImg(index)"
              >
                <i class="el-icon-picture-outline"></i>
                <span>{{ item.fileList }}</span>
              </el-tag>
              <el-tag
                class="tag-annex"
                v-for="(item, index) in pdfSrc"
                :key="'pdf' + index"
                closable
                size="medium"
                :disable-transitions="false"
                @close="handleDelPdf(index)"
                @click="seePdf(item)"
              >
                <i class="el-icon-document"></i>
                <span>{{ item.fileList }}</span>
              </el-tag>
            </div>
          </el-form>

          <!-- 使用提示 -->
          <div class="ai-tip">
            <i class="el-icon-warning-outline"></i>
            使用提示：AI自动生成英文回复并翻译为中文 → 客服可直接编辑左侧中文 →
            点击"翻译"更新右侧英文 → 点击"发送"发出邮件
          </div>
        </div>
      </div>

      <!-- 订单信息 -->
      <div
        class="order-box"
        v-if="scope.mailType == 9 || scope.mailType == 3"
        v-loading="isOrderInfo"
      >
        <div v-if="scope.mailType == 9">
          <template v-if="orderInfo.length > 0">
            <div v-if="orderInfo.length > 1">
              <el-button
                v-for="(item, index) in orderInfo.length"
                :key="index"
                type="primary"
                size="mini"
                @click="getInfo(index)"
              >
                {{ item }}
              </el-button>
            </div>

            <p>
              订单编号：{{ infoObj.order_id }}
              <el-button
                type="primary"
                v-if="isEmail && infoObj.order_id"
                @click="applyClick()"
                size="mini"
                >发起退款</el-button
              >
            </p>
            <p>平台订单号：{{ infoObj.platform_order_id }}</p>
            <p>收件人：{{ infoObj.addressee }}</p>
            <p>
              配货状态：{{
                $getText(
                  infoObj.distribution_status,
                  this.dropList.OrderDistributionStatus
                )
              }}
            </p>
            <p>物流跟踪号：{{ infoObj.express_number }}</p>
            <p>物流方式：{{ infoObj.logistics_name }}</p>
            <p>时间：{{ infoObj.delivery_date }}</p>
            <p>最早预计送达时间：{{ infoObj.earliest_arrival_time }}</p>
            <p>最晚预计送达时间：{{ infoObj.latest_arrival_time }}</p>
            <p>订单总价：{{ infoObj.order_amount }}</p>
            <p>账号：{{ infoObj.account_number }}</p>
            <p>
              订单状态：{{
                $getText(infoObj.order_status, this.dropList.OrderOrderStatus)
              }}
            </p>
            <p>币种：{{ infoObj.order_currency }}</p>
            <p style="padding: 5px"></p>
          </template>
          <el-empty v-else description="暂无订单信息"></el-empty>
          <h3>订单明细</h3>
          <commonTable
            ref="multipleTable"
            :isExpand="false"
            :isPage="false"
            :tableData="infoObj.skuInfo"
            :tableLabel="tableLabel"
          ></commonTable>
        </div>
        <div v-else>
          <template>
            <el-form label-position="right" v-if="this.qaObj != {}">
              <el-form-item label="产品名称：">{{
                qaObj.titleCn
              }}</el-form-item>
              <el-form-item label="产品sku：">{{ qaObj.sku }}</el-form-item>
              <el-form-item label="亚马逊链接：">
                <span class="clickClass" @click="openUrl(qaObj.productUrl)">{{
                  qaObj.productUrl
                }}</span>
              </el-form-item>
              <el-form-item label="价格：">{{ qaObj.newPrice }}</el-form-item>
              <el-form-item label="产品图片：">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="qaObj.productImg[0]"
                  :preview-src-list="qaObj.productImg"
                ></el-image>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="huifuClass(qaObj.feedbacklink)"
                  >回复</el-button
                >
              </el-form-item>
            </el-form>
            <el-empty v-else description="暂无订单信息"></el-empty>
          </template>
        </div>
      </div>
    </div>

    <imgView
      :dialog.sync="isShowImg"
      :imgList="imgView_msg.list"
      :imgIndex="imgView_msg.index"
      :ImgUrl="ImgUrl"
    ></imgView>
    <applyRefund
      v-if="isRefund"
      @isShowEdit="closeApply"
      @getList="getDetail"
      :platform="platform"
      :orderID="infoObj.order_id"
    ></applyRefund>
    <look v-if="lookShow" :scope="lookObj" @isShowEdit="closeApply"></look>
    <el-button
      v-if="isBottom"
      @click="toBottom"
      size="medium"
      circle
      class="to-bottom"
      icon="el-icon-caret-bottom"
    ></el-button>

    <!-- 提供回复建议 弹窗 -->
    <el-dialog
      title="提供回复建议"
      :visible.sync="suggestDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="suggest-dialog"
    >
      <p class="suggest-desc">
        请输入您对这封邮件的回复建议或要点，AI将基于您的建议重新生成更符合预期的回复内容。
      </p>
      <el-form
        ref="suggestForm"
        :model="suggestForm"
        :rules="suggestRules"
        label-position="top"
      >
        <el-form-item label="回复建议" prop="suggestion">
          <el-input
            type="textarea"
            v-model="suggestForm.suggestion"
            :rows="8"
            placeholder="例如：需要强调我们有专业的技术团队，可以提供7x24小时支持；重点说明迁移过程零风险；语气要更友好亲切..."
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="suggest-tip">
        <i class="el-icon-warning-outline"></i>
        提示：建议越具体，AI生成的回复越精准。您可以包含关键信息点、语气要求、重点强调的内容等。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSuggestDialog">取消</el-button>
        <el-button
          type="primary"
          :loading="aiLoading"
          @click="submitSuggestion"
        >
          提交并生成
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 亚马逊邮件 AI 详情/回复页组件
 * 功能：展示邮件正文与附件、历史邮件切换，AI 双栏编辑（左侧中文译文可编辑、右侧 AI 生成英文原文）、
 *       中文翻译为英文、富文本格式化、标记邮件、上传附件、发送/存草稿、订单信息与退款、可提交建议重新生成 AI 回复
 */
import {
  amazonEmailDetail,
  replyEmail,
  outlookReplyEmail,
  getLanguage,
  saveDrafts,
  singRed,
  translate,
  updateStatus,
  getAmazonMailTitle,
  getAmazonMessageById,
  getAmazonMessageOrder,
  getTemplate,
  requestAmazonDify,
} from "@/api/user";
import imgView from "../components/imgView";
import applyRefund from "../../afterSale/components/applyRefund";
import look from "../components/look";
import serverPath from "@/config/config.js";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isEmail: {
      type: Boolean,
      default: true,
    },
  },
  components: { imgView, applyRefund, look },
  data() {
    return {
      // 亚马逊平台id
      platform: 1,
      // 是否打开发起退款弹窗
      isRefund: false,
      // 详情加载状态
      loading: true,
      // 页面整体加载状态
      loadingReply: true,
      // AI 重新生成中的加载状态
      aiLoading: false,
      // 是否设置为模板
      checked: "",
      // 订单信息加载状态
      isOrderInfo: true,
      // 是否显示返回底部按钮
      isBottom: false,
      // 买家咨询的产品信息（mailType == 3 时展示）
      qaObj: {},
      // AI 生成信息（数据源/生成时间）
      aiInfo: {
        dataSource: "物流节点",
        generateTime: "",
      },
      tableLabel: [
        {
          label: "SKU",
          param: "sku",
          align: "center",
          show: true,
          render: (h, param) => {
            return h(
              "span",
              {
                style: { color: "rgb(64, 158, 255)", cursor: "pointer" },
                on: {
                  click: () => {
                    this.lookObj.sku = param.row.sku;
                    this.lookShow = true;
                  },
                },
              },
              param.row.sku
            );
          },
        },
        { label: "SKU名称", param: "sku_name", align: "center", show: true },
        {
          label: "订单数量",
          param: "product_quantity",
          align: "center",
          show: true,
        },
      ],
      // 附件上传地址
      url: "/crm/yy-attachment/upload/images",
      // 上传成功的图片地址列表
      imgUploadList: [],
      // 上传成功的图片名称列表
      imgName: [],
      // 上传成功的图片地址（当前未使用）
      imgSrc: [],
      // 上传成功的 pdf 附件列表
      pdfSrc: [],
      // 是否打开图片查看弹窗
      isShowImg: false,
      imgView_msg: { show: false, index: 0, list: [] },
      // 上传附加参数
      uploadObj: {},
      // 回复邮件表单数据：发件/收件地址、标题、正文、附件、模板、备注等
      dataObj: {
        senderAddress: "",
        senderAccount: "",
        recipientAddress: "",
        title: "",
        content: "",
        picture: null,
        templateId: "",
        remark: "",
        temLanguages: "",
        temType: "",
        email: "",
        id: "",
        amazonMessageId: "",
      },
      // 左侧中文译文内容（富文本 HTML）
      cnContent: "",
      // 邮件详情返回的图片
      mailImg: [],
      // 邮件详情返回的 pdf 附件
      mailPdf: [],
      // 订单信息列表（多订单时切换展示）
      orderInfo: [],
      // 当前展示的订单详情
      infoObj: {},
      // 邮件详情数据
      mailObj: {},
      // 语种列表
      languageArr: [],
      langObj: { from: "zh", to: "en", query: "" },
      rules: {
        recipientAddress: [
          { required: true, message: "请输入收件人", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "change" }],
      },
      // 是否打开产品资料查看弹窗
      lookShow: false,
      // 产品资料弹窗参数（sku）
      lookObj: {},
      // 选中的邮件标记类型（重要/待办/垃圾）
      mailTxt: "",
      mailType: [
        { name: "重要邮件", key: "isImportant" },
        { name: "待办邮件", key: "isTodo" },
        { name: "垃圾邮件", key: "isGarbage" },
      ],
      // 历史邮件列表（供切换查询）
      MailList: [],
      // 选中的历史邮件 id
      mailTitle: "",
      // 重新生成AI回复 弹窗
      suggestDialogVisible: false,
      suggestForm: {
        suggestion: "",
      },
      suggestRules: {
        suggestion: [
          { required: true, message: "请输入回复建议", trigger: "blur" },
        ],
      },
      // 富文本编辑相关
      // 当前激活的编辑器（cn 中文 / en 英文）
      activeEditor: "cn",
      // 富文本保存的选区
      savedRange: null,
      // 工具栏选中的块级格式
      blockFormat: "",
      // 工具栏选中的字号
      sizeFormat: "",
    };
  },
  watch: {
    // 中文译文变化时同步到左侧编辑器内容
    cnContent(val) {
      const el = this.$refs.cnEditor;
      if (el && el.innerHTML !== (val || "")) {
        el.innerHTML = val || "";
      }
    },
    // 英文正文变化时同步到右侧编辑器内容
    "dataObj.content"(val) {
      const el = this.$refs.enEditor;
      if (el && el.innerHTML !== (val || "")) {
        el.innerHTML = val || "";
      }
    },
  },
  computed: {
    tabcolors() {
      return this.$store.getters.color;
    },
    templateList() {
      return this.$store.getters.dropList.templateName;
    },
    dropList() {
      return this.$store.getters.dropList;
    },
    ImgUrl() {
      const env = serverPath.env;
      if (env === "test" || env === "dev" || env === "localhost") {
        return serverPath.serverPath.server + "/";
      } else {
        return "http://images.delaman168.com/crm/";
      }
    },
  },
  mounted() {
    // 页面挂载时初始化下拉数据、邮件详情、历史邮件，并回填双栏编辑器内容
    this.init();
    this.getDetail();
    this.getTitle();
    this.setAiGenerateTime();
    this.$nextTick(() => {
      if (this.$refs.cnEditor) {
        this.$refs.cnEditor.innerHTML = this.cnContent || "";
      }
      if (this.$refs.enEditor) {
        this.$refs.enEditor.innerHTML = this.dataObj.content || "";
      }
    });
  },
  created() {
    // 监听页面滚动，用于显示返回底部按钮
    window.addEventListener("scroll", this.watchScroll, true);
  },
  methods: {
    /** 监听滚动位置，超过阈值时显示返回底部按钮 */
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.querySelector(".scroll").scrollTop ||
        document.body.scrollTop;
      this.isBottom = scrollTop > 20;
    },
    /** 滚动到页面底部 */
    toBottom() {
      let top = document.querySelector(".scroll").scrollHeight;
      document.querySelector(".scroll").scrollTop = top;
    },
    /** 设置 AI 回复的生成时间（当前时间，精确到秒） */
    setAiGenerateTime() {
      const d = new Date();
      const pad = (n) => (n < 10 ? "0" + n : n);
      this.aiInfo.generateTime =
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds());
    },
    /** 初始化下拉数据（模板、订单状态、语种等）与语种列表 */
    init() {
      this.$store.dispatch("getDropListTwo", [
        "templateName",
        "OrderDistributionStatus",
        "OrderOrderStatus",
        "TemplateLanguages",
        "TemplateType",
      ]);
      getLanguage().then((res) => {
        if (res.code === 200) {
          this.languageArr = res.data;
        }
      });
    },
    // 语种交换
    changeSort() {
      const to = this.langObj.to;
      const from = this.langObj.from;
      this.langObj.to = from;
      this.langObj.from = to;
    },
    // 聚焦左侧中文译文输入区
    setContent() {
      const el = this.$refs.cnEditor;
      if (el) el.focus();
    },
    // 富文本：保存选区
    saveSelection() {
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        const editor =
          this.activeEditor === "en"
            ? this.$refs.enEditor
            : this.$refs.cnEditor;
        if (editor && editor.contains(range.commonAncestorContainer)) {
          this.savedRange = range.cloneRange();
        }
      }
    },
    // 富文本：恢复选区并聚焦
    restoreSelection() {
      const editor =
        this.activeEditor === "en" ? this.$refs.enEditor : this.$refs.cnEditor;
      if (!editor) return;
      editor.focus();
      if (this.savedRange) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(this.savedRange);
      }
    },
    // 富文本：执行格式化命令
    exec(command, value) {
      this.restoreSelection();
      document.execCommand(command, false, value || null);
      this.syncContent();
      this.$nextTick(() => this.saveSelection());
    },
    /** 工具栏块级格式（标题/引用）变化时执行格式化 */
    onBlockChange() {
      if (this.blockFormat) this.exec("formatBlock", this.blockFormat);
      this.blockFormat = "";
    },
    /** 工具栏字号变化时执行格式化 */
    onSizeChange() {
      if (this.sizeFormat) this.exec("fontSize", this.sizeFormat);
      this.sizeFormat = "";
    },
    /** 左侧中文编辑器输入时同步内容 */
    onCnInput(e) {
      this.cnContent = e.target.innerHTML;
    },
    /** 右侧英文编辑器输入时同步内容 */
    onEnInput(e) {
      this.dataObj.content = e.target.innerHTML;
    },
    /** 同步双栏编辑器内容到对应数据字段 */
    syncContent() {
      if (this.$refs.cnEditor) {
        this.cnContent = this.$refs.cnEditor.innerHTML;
      }
      if (this.$refs.enEditor) {
        this.dataObj.content = this.$refs.enEditor.innerHTML;
      }
    },
    /** 剥离 HTML 标签返回纯文本（用于判断正文是否为空） */
    stripHtml(html) {
      if (!html) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return (tmp.textContent || tmp.innerText || "").trim();
    },
    // 将后端返回的内容转换为可在富文本编辑器中渲染的 HTML
    // - 纯文本：转义后按段落 / 换行包装成 <p><br>
    // - 已含 HTML 标签：保留标签原样渲染，仅把残留的纯文本换行转为 <br>
    formatPlainTextToHtml(text) {
      if (text == null || text === "") return "";
      const str = String(text)
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");
      const hasHtml = /<[a-z!/][\s\S]*?>/i.test(str);
      if (hasHtml) {
        // 含 HTML 标签：标签原样渲染；先把"紧贴标签的换行"合并掉，避免在块级标签之间叠加空行，再把剩余换行转为 <br>
        return str
          .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
          .replace(/>\s*\n+\s*</g, "><")
          .replace(/\n/g, "<br>");
      }
      // 纯文本：转义 HTML 特殊字符后按段落 / 换行包装
      const escaped = str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
      return escaped
        .split(/\n{2,}/)
        .map((p) => "<p>" + p.replace(/\n/g, "<br>") + "</p>")
        .join("");
    },
    // 后端中文译文用字面 n/N/nn/N1/N2 等代替换行，格式不固定。
    // 统一策略：匹配含 n/N 的换行标记（两侧非英文字母），全部转为真实换行。
    // 英文单词内的 n（如 Amazon/information）不受影响。
    formatCnReplyToHtml(text) {
      if (text == null || text === "") return "";
      const str = String(text);
      const hasHtml = /<[a-z!/][\s\S]*?>/i.test(str);
      if (hasHtml) return this.formatPlainTextToHtml(str);

      let result = str;
      // 1. nn / NN / Nn / nN → 段落分隔（双换行）
      result = result.replace(/(^|[^a-zA-Z])[Nn]{2}(?![a-zA-Z])/g, '$1\n\n');
      // 2. N1。/n1。/N12。/n12 → 换行（字母+数字+可选句号）
      result = result.replace(/(^|[^a-zA-Z])[Nn]\d{1,2}[。.]?/g, '$1\n');
      // 3. 独立 n / N（两侧非英文，后面不跟数字）→ 换行
      result = result.replace(/(^|[^a-zA-Z])[Nn](?![a-zA-Z\d])/g, '$1\n');

      return this.formatPlainTextToHtml(result);
    },
    // 标记邮件
    markMail() {
      if (this.mailTxt === "") {
        this.$message.warning("请先选择标记类型！");
        return false;
      }
      let param = {
        id: this.dataObj.id,
        [this.mailTxt]: 1,
      };
      updateStatus(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
        }
      });
    },
    // 历史邮件查询
    getTitle() {
      let param = {
        sender: this.scope.sender,
        recipiens: this.scope.recipients,
      };
      this.MailList = [];
      getAmazonMailTitle(param).then((res) => {
        if (res.code === 200) {
          if (res.data.pageInfo && res.data.pageInfo.length > 0) {
            res.data.pageInfo.forEach((item) => {
              this.MailList.push({
                id: item.id,
                title: item.sendDate + " | " + item.subject,
              });
            });
          }
        }
      });
    },
    /**
     * 切换历史邮件时按 id 查询该邮件的 AI 回复并回填双栏编辑器
     * @param {String} val 历史邮件 id
     */
    setMailDetail(val) {
      if (val !== "") {
        getAmazonMessageById({ id: val }).then((res) => {
          if (res.code === 200) {
            this.mailObj = res.data;
            this.dataObj.title = this.mailObj.aiReplySubject;
            this.cnContent = this.formatCnReplyToHtml(this.mailObj.aiReplyCn);
            this.dataObj.content = this.formatPlainTextToHtml(
              this.mailObj.aiReplyEn
            );
            this.dataObj.senderAccount = this.mailObj.recipients;
            this.dataObj.recipientAddress = this.mailObj.sender;
            this.dataObj.senderAddress = this.mailObj.recipients;
            this.dataObj.email = this.mailObj.email;
            this.dataObj.id = this.mailObj.id;
          }
        });
      }
    },
    // 翻译：左侧中文 → 右侧英文（纯文本发送，接口返回后还原换行）
    translateClick() {
      const html = this.cnContent;
      if (!html) {
        this.$message.warning("请先输入左侧中文译文");
        return;
      }
      // 剥离所有 HTML 标签，只发纯文本
      const plainText = this.htmlToTranslationText(html);
      const param = {
        from: this.langObj.from,
        to: this.langObj.to,
        query: plainText,
      };
      this.dataObj.content = "<p>正在翻译，请稍等....</p>";
      translate(param).then((res) => {
        if (res.code === 200) {
          this.dataObj.content = this.translationTextToHtml(res.data);
        }
      });
    },
    // 将 HTML 转为带字母占位符的纯文本，保护结构和格式不被百度翻译破坏
    htmlToTranslationText(html) {
      if (!html) return '';
      return html
        // 段落/换行
        .replace(/<p\b[^>]*>/gi, '')
        .replace(/<\/p>/gi, ' ZPZ ')
        .replace(/<br\s*\/?>/gi, ' ZBZ ')
        .replace(/<\/div>/gi, ' ZPZ ')
        .replace(/<div\b[^>]*>/gi, '')
        // 加粗
        .replace(/<(?:b|strong)\b[^>]*>/gi, ' ZBDZ ')
        .replace(/<\/(?:b|strong)>/gi, ' ZBDE ')
        // 斜体
        .replace(/<(?:i|em)\b[^>]*>/gi, ' ZITZ ')
        .replace(/<\/(?:i|em)>/gi, ' ZITE ')
        // 下划线
        .replace(/<u\b[^>]*>/gi, ' ZUNZ ')
        .replace(/<\/u>/gi, ' ZUNE ')
        // 标题
        .replace(/<h1\b[^>]*>/gi, ' ZH1Z ')
        .replace(/<\/h1>/gi, ' ZH1E ')
        .replace(/<h2\b[^>]*>/gi, ' ZH2Z ')
        .replace(/<\/h2>/gi, ' ZH2E ')
        .replace(/<h3\b[^>]*>/gi, ' ZH3Z ')
        .replace(/<\/h3>/gi, ' ZH3E ')
        // 去掉其余标签和实体
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        // 清理重复
        .replace(/\bZPZ\s+ZPZ\b/g, 'ZPZ')
        .replace(/\bZBZ\s+ZBZ\b/g, 'ZBZ')
        .replace(/\s+/g, ' ')
        .trim();
    },
    // 将百度翻译返回的结果还原为 HTML
    translationTextToHtml(translated) {
      let text = String(translated);
      // 还原占位符 → HTML 标签
      const tagMap = [
        ['ZPZ', '</p><p>'], ['ZBZ', '<br>'],
        ['ZBDZ', '<b>'],   ['ZBDE', '</b>'],
        ['ZITZ', '<i>'],   ['ZITE', '</i>'],
        ['ZUNZ', '<u>'],   ['ZUNE', '</u>'],
        ['ZH1Z', '<h1>'],  ['ZH1E', '</h1>'],
        ['ZH2Z', '<h2>'],  ['ZH2E', '</h2>'],
        ['ZH3Z', '<h3>'],  ['ZH3E', '</h3>'],
      ];
      tagMap.forEach(([marker, tag]) => {
        text = text.replace(new RegExp('\\s*' + marker + '\\s*', 'gi'), tag);
      });
      // 兜底
      if (!/<[a-z!/][\s\S]*?>/i.test(text) && !/<p>/i.test(text)) {
        text = text
          .replace(/(^|[^a-zA-Z])[Nn]{2}(?![a-zA-Z])/g, '$1</p><p>')
          .replace(/(^|[^a-zA-Z])[Nn]\d{1,2}[。.]?/g, '$1</p><p>')
          .replace(/(^|[^a-zA-Z])[Nn](?![a-zA-Z\d])/g, '$1<br>');
      }
      let html = '<p>' + text + '</p>';
      html = html.replace(/<p>\s*<\/p>/g, '');
      return html || '<p>' + String(translated) + '</p>';
    },
    // 打开「提供回复建议」弹窗
    regenerateAI() {
      this.suggestForm.suggestion = "";
      this.suggestDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.suggestForm && this.$refs.suggestForm.clearValidate();
      });
    },
    /** 关闭「提供回复建议」弹窗 */
    closeSuggestDialog() {
      this.suggestDialogVisible = false;
    },
    // 提交建议并重新生成
    submitSuggestion() {
      this.$refs.suggestForm.validate((valid) => {
        if (!valid) return;
        this.aiLoading = true;
        const param = {
          idsList: [this.scope.id],
          suggestion: this.suggestForm.suggestion,
        };
        requestAmazonDify(param)
          .then((res) => {
            if (res.code === 200) {
              const msg = res.data.amazonMessage || {};
              this.mailObj.aiReplySubject = msg.aiReplySubject;
              this.mailObj.aiReplyCn = msg.aiReplyCn;
              this.mailObj.aiReplyEn = msg.aiReplyEn;
              this.dataObj.title = msg.aiReplySubject;
              this.cnContent = this.formatCnReplyToHtml(msg.aiReplyCn);
              this.dataObj.content = this.formatPlainTextToHtml(msg.aiReplyEn);
              this.setAiGenerateTime();
              this.suggestDialogVisible = false;
              this.$message.success("AI 回复已重新生成");
            }
          })
          .finally(() => {
            this.aiLoading = false;
          });
      });
    },
    /** 设置邮件为已读 */
    setRed() {
      let param = { id: this.scope.id, status: 1 };
      singRed(param).then(() => {});
    },
    /** 查询邮件详情：回填 AI 回复、附件与订单信息，进入页面自动置已读 */
    getDetail() {
      if (this.emailType !== "drafts") {
        this.setRed();
      }
      let obj = {
        messageId: this.scope.messageId,
        email: this.scope.sender,
      };
      amazonEmailDetail(obj).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          this.loadingReply = false;
          this.mailObj = res.data.yyAmazonMessage;
          this.dataObj.title = this.mailObj.aiReplySubject;
          this.cnContent = this.formatCnReplyToHtml(this.mailObj.aiReplyCn);
          this.dataObj.content = this.formatPlainTextToHtml(
            this.mailObj.aiReplyEn
          );
          this.dataObj.senderAccount = this.mailObj.recipients;
          this.dataObj.recipientAddress = this.mailObj.sender;
          this.dataObj.senderAddress = this.mailObj.recipients;
          this.dataObj.email = this.mailObj.email;
          this.dataObj.id = this.mailObj.id;
          const newArr = res.data.yyAttachment || [];
          newArr.forEach((item) => {
            if (this.isImageAttachment(item)) {
              this.mailImg.push(item.attachmentPath);
            } else {
              this.mailPdf.push(item);
            }
          });
        }
      });
      if (this.scope.mailType == 9 || this.scope.mailType == 3) {
        let param = {
          mailType: this.scope.mailType,
          sender: this.scope.mailType == 3 ? this.scope.id : this.scope.sender,
        };
        this.isOrderInfo = true;
        getAmazonMessageOrder(param).then((res) => {
          if (res.code === 200) {
            this.isOrderInfo = false;
            if (this.scope.mailType == 9) {
              this.orderInfo = res.data.amazonOrderVO;
              this.infoObj = this.orderInfo[0] ? this.orderInfo[0] : "";
            } else {
              this.qaObj = res.data;
            }
          }
        });
      }
    },
    /** 关闭退款/产品资料弹窗 */
    closeApply() {
      this.isRefund = false;
      this.lookShow = false;
    },
    /** 打开发起退款弹窗 */
    applyClick() {
      this.isRefund = true;
    },
    /** 切换展示指定下标的订单信息 */
    getInfo(index) {
      this.infoObj = this.orderInfo[index];
    },
    /** 选择模板时按模板名查询内容填充双栏编辑器（未选择时还原 AI 回复内容） */
    changeTemplate(value) {
      if (value) {
        getTemplate({ name: value }).then((res) => {
          if (res.code === 200) {
            this.cnContent = res.data;
            this.dataObj.content = res.data;
          }
        });
      } else {
        this.cnContent = this.formatCnReplyToHtml(this.mailObj.aiReplyCn);
        this.dataObj.content = this.formatPlainTextToHtml(
          this.mailObj.aiReplyEn
        );
      }
    },
    /** 判断附件是否为浏览器可直接预览的图片 */
    isImageAttachment(item) {
      const fileName = item.attachmentName || item.messageCid || "";
      const extension = fileName.split(".").pop().toLowerCase();
      return [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "webp",
        "bmp",
        "svg",
        "ico",
        "avif",
      ].includes(extension);
    },
    /** 新窗口打开非图片附件 */
    toTab(val) {
      window.open(val.attachmentPath, "_blank");
    },
    /** 移除已上传的图片附件 */
    handleDel(index) {
      this.imgName.splice(index, 1);
      this.imgSrc.splice(index, 1);
      this.dataObj.picture && this.dataObj.picture.splice(index, 1);
    },
    /** 移除已上传的 pdf 附件 */
    handleDelPdf(index) {
      this.pdfSrc.splice(index, 1);
    },
    /** 关闭页面并通知父组件刷新列表 */
    close() {
      this.$emit("isShowEdit");
      this.$emit("getList");
    },
    // 根据 email 后缀选择 Outlook Graph 或原有回复接口
    send() {
      this.dataObj.messageId = this.scope.messageId;
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if (!this.stripHtml(this.dataObj.content)) {
          this.$message.error(
            '右侧英文正文为空，请先编辑左侧中文并点击"翻译"生成英文，或直接在右侧输入英文'
          );
          return;
        }
        this.dataObj.amazonMessageId = this.scope.id;
        // 仅根据 email 判断：去除首尾空格，大小写不敏感地匹配 @outlook.com。
        // Hotmail 及其他邮箱继续使用原回复接口。
        const email = (this.dataObj.email || "").trim();
        const isOutlook = /@outlook\.com$/i.test(email);
        // 复制表单参数，Outlook 专用字段不写回表单；picture 沿用上传后的附件路径数组。
        const params = { ...this.dataObj };
        if (isOutlook) {
          params.email = email;
          // 优先使用当前展示邮件的 Graph ID，兼容详情未返回时使用列表传入的 ID。
          params.messageId = this.mailObj.messageId || this.scope.messageId;
          // 富文本正文按 HTML 发送，1 表示仅回复发件人。
          params.contentType = "HTML";
          params.replyType = 1;
          // 生成 32 位十六进制幂等 ID（不超过 64 位）；同一次请求重试应复用此 ID。
          params.requestId = Array.from(
            window.crypto.getRandomValues(new Uint8Array(16)),
            (value) => ("0" + value.toString(16)).slice(-2)
          ).join("");
        }
        const sendReply = isOutlook ? outlookReplyEmail : replyEmail;
        sendReply(params).then((result) => {
          if (result.code == 200) {
            this.$message.success("发送成功");
            this.dataObj.content = "";
            this.close();
          }
        });
      });
    },
    /** 校验后存为草稿（英文正文为空时拦截） */
    saveSlide() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
          if (!this.stripHtml(this.dataObj.content)) {
          this.$message.error(
            '右侧英文正文为空，请先编辑左侧中文并点击"翻译"生成英文，或直接在右侧输入英文'
          );
          return;
        }
        saveDrafts(this.dataObj).then((result) => {
          if (result.code == 200) {
            this.$message.success("保存成功");
            this.dataObj.content = "";
          }
        });
      });
    },
    /** 上传成功回调（当前为空实现） */
    getImgName() {},
    /** 上传成功后按文件类型区分图片/pdf 并回填附件列表 */
    getImgSrc(val) {
      val.forEach((item) => {
        this.imgUploadList.push(item.urlList);
        if (item.fileList.split(".")[1] == "pdf") {
          this.pdfSrc.push(item);
        } else {
          this.imgName.push(item);
          this.imgView_msg.list.push(item.urlList);
        }
      });
      this.dataObj.picture = this.imgUploadList;
    },
    /** 新窗口打开 pdf 附件预览 */
    seePdf(item) {
      window.open(this.ImgUrl + item.urlList, "_blank");
    },
    /** 打开图片查看弹窗（定位到指定下标） */
    seeImg(index) {
      this.imgView_msg.index = index;
      this.isShowImg = true;
    },
    /** 新窗口打开外部链接（亚马逊产品链接） */
    openUrl(value) {
      window.open(value, "_blank");
    },
    /** 新窗口打开中差评回复链接 */
    huifuClass(value) {
      window.open(value, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.padding10px {
  padding: 10px !important;
}

.toText-css {
  margin-top: 7px;
  margin-bottom: 5px;
  text-align: center;
  width: 40px;
  display: inline-block;
  cursor: pointer;
  transform: rotate(90deg);
}

.replay-div {
  display: flex;
  align-items: flex-start;

  .mail-detail {
    width: 70%;
    margin-right: 30px;

    .border-box {
      border: 1px solid #ebeef5;
      border-radius: 10px;
      padding: 10px;
      margin-bottom: 20px;
    }
  }

  .order-box {
    width: 25%;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    padding: 10px;

    p {
      font-size: 14px;
      color: #333333;
      line-height: 30px;
    }
  }
}

.ai-panel {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  background: #ffffff;
}

.ai-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 16px;

  .ai-title {
    display: flex;
    align-items: center;

    .ai-icon {
      font-size: 18px;
      margin-right: 6px;
    }

    .ai-title-text {
      font-size: 15px;
      font-weight: bold;
      color: #303133;
      margin-right: 16px;
    }

    .ai-source {
      font-size: 13px;
      color: #606266;
    }
  }

  .ai-gen-time {
    font-size: 12px;
    color: #909399;
  }
}

.ai-form {
  ::v-deep .el-form-item__label {
    padding: 0 0 4px 0;
    line-height: 1.5;
    font-size: 13px;
    color: #303133;
  }

  .content-item {
    margin-bottom: 12px;
  }

  .template-item {
    margin-bottom: 12px;
  }
}

.ai-toolbar {
  border: 1px solid #dcdfe6;
  border-radius: 4px 4px 0 0;
  padding: 6px 10px;
  background: #fafafa;
  font-size: 13px;
  color: #606266;
  display: flex;
  align-items: center;
  border-bottom: none;

  .tool-btn {
    display: inline-block;
    padding: 0 8px;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: #409eff;
    }
  }

  .tool-divider {
    width: 1px;
    height: 16px;
    background: #dcdfe6;
    margin: 0 6px;
  }

  .tool-select {
    display: inline-block;
    padding: 2px 8px;
    margin-left: 8px;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    background: #fff;
    cursor: pointer;
    font-size: 12px;
    outline: none;
    height: 24px;
    line-height: 1;

    &:hover {
      border-color: #c0c4cc;
    }
  }
}

.bilingual-wrap {
  display: flex;
  gap: 12px;
  border: 1px solid #dcdfe6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 10px;
  background: #fff;

  .bilingual-col {
    flex: 1;
    min-width: 0;
  }

  .bilingual-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    font-size: 12px;
    color: #606266;

    .lang-select {
      width: 110px;
    }
  }

  .rich-editor {
    height: 420px;
    overflow-y: auto;
    padding: 10px 12px;
    border-radius: 4px;
    font-size: 13px;
    line-height: 1.7;
    color: #303133;
    outline: none;
    word-break: break-word;

    &:empty:before {
      content: attr(data-placeholder);
      color: #c0c4cc;
      pointer-events: none;
    }

    h1 {
      font-size: 20px;
      font-weight: bold;
      margin: 8px 0;
    }
    h2 {
      font-size: 17px;
      font-weight: bold;
      margin: 6px 0;
    }
    h3 {
      font-size: 15px;
      font-weight: bold;
      margin: 4px 0;
    }
    p {
      margin: 4px 0;
    }
    blockquote {
      border-left: 3px solid #dcdfe6;
      padding-left: 10px;
      color: #606266;
      margin: 6px 0;
    }
  }

  .cn-editor {
    background: #f0f9eb;
    border: 1px solid #e1f3d8;

    &:focus {
      border-color: #c2e7b0;
    }
  }

  .en-editor {
    background: #ecf5ff;
    border: 1px solid #d9ecff;

    &:focus {
      border-color: #a0cfff;
    }
  }
}

.translate-row {
  display: flex;
  align-items: center;
  margin-top: 10px;

  .translate-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }
}

.action-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.annex-wrap {
  margin-top: 10px;

  .tag-annex {
    margin-right: 12px;
    margin-bottom: 6px;
    cursor: pointer;
  }
}

.ai-tip {
  margin-top: 16px;
  padding: 10px 14px;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  color: #e6a23c;
  font-size: 13px;
  line-height: 1.6;

  i {
    margin-right: 6px;
  }
}

.border-box ::v-deep a {
  pointer-events: none !important;
}

.clickClass {
  cursor: pointer;
  color: #409eff;
}
</style>

<style lang="scss">
.suggest-dialog {
  .suggest-desc {
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
    margin: 0 0 14px;
  }

  .suggest-tip {
    margin-top: 12px;
    padding: 10px 14px;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 4px;
    color: #e6a23c;
    font-size: 13px;
    line-height: 1.6;

    i {
      margin-right: 6px;
    }
  }
}
</style>
